export default __webpack_public_path__ + "alberta-dot-yes.7fbdf904c6c48def1ad7.svg";